import * as v from "valibot";

import { rpcContract } from "../rpc";

export const adminInfluencersRpcContract = rpcContract({
  name: "adminInfluencers",
  paramsSchema: v.object({
    limit: v.pipe(v.optional(v.number(), 25), v.minValue(1), v.maxValue(50)),
    offset: v.pipe(v.optional(v.number(), 0), v.minValue(0)),
    search: v.optional(v.string()),
    profileComplete: v.optional(v.picklist(["yes", "no"])),
    isActive: v.optional(v.picklist(["yes", "no"])),
    isStaff: v.optional(v.picklist(["yes", "no"])),
    isVerified: v.optional(v.picklist(["yes", "no"])),
    sortBy: v.optional(v.picklist(["handle", "email", "wowLinksCount", "dateJoined"])),
    sortOrder: v.optional(v.picklist(["asc", "desc"])),
  }),
  resultSchema: v.object({
    influencers: v.array(
      v.object({
        id: v.string(),
        handle: v.string(),
        bio: v.nullable(v.string()),
        email: v.string(),
        profileImage: v.nullable(v.string()),
        wowLinksCount: v.nullable(v.number()),
        lastWowLinkCheck: v.nullable(v.string()), // ISO date string
        isActive: v.boolean(),
        isStaff: v.boolean(),
        isVerified: v.boolean(),
        dateJoined: v.string(), // ISO date string
        featureFlags: v.array(v.string()),
      }),
    ),
    totalCount: v.number(),
  }),
});

export type AdminInfluencersParams = v.InferOutput<(typeof adminInfluencersRpcContract)["paramsSchema"]>;
export type AdminInfluencersResult = v.InferOutput<(typeof adminInfluencersRpcContract)["resultSchema"]>;
export type AdminInfluencer = v.InferOutput<(typeof adminInfluencersRpcContract)["resultSchema"]>["influencers"][0];
